import { render, staticRenderFns } from "./ClientProduct.vue?vue&type=template&id=0b305307&scoped=true&lang=pug&"
import script from "./ClientProduct.vue?vue&type=script&lang=js&"
export * from "./ClientProduct.vue?vue&type=script&lang=js&"
import style0 from "./ClientProduct.vue?vue&type=style&index=0&id=0b305307&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b305307",
  null
  
)

export default component.exports